import { getCookie } from '.';

const eventTypeMap = new Map<
  string,
  {
    subscribe: Function[];
    oldValue?: string | null;
  }
>();

function timerfn() {
  eventTypeMap.forEach((item, key) => {
    const newValue = getCookie(key);
    const oldValue = item.oldValue;

    if (newValue !== oldValue) {
      item.subscribe.forEach((fn) => fn({ value: newValue, oldValue }));
      item.oldValue = newValue;
    }
  });

  setTimeout(() => {
    timerfn();
  }, 700);
  // 获取绑定手机号
}

timerfn();

const customCookieEventListener = (key: string, fn) => {
  if (!key) return;
  const oldValue = getCookie(key);
  if (!eventTypeMap.has(key)) {
    eventTypeMap.set(key, {
      subscribe: [],
      oldValue: oldValue,
    });
  }
  const curentMap = eventTypeMap.get(key)!;
  curentMap.subscribe.push(fn);

  return () => {
    const index = curentMap.subscribe.indexOf(fn);
    if (index !== -1) {
      curentMap.subscribe.splice(index, 1);
    }
  };
};

export default customCookieEventListener;
